module.exports = __webpack_public_path__ + "img/IT0000570208854.30dc3023.png";